import React from "react";
import { useTheme } from "../../Context/ThemeContext";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { Moon, Sun } from "../../Assets/Icons";

interface IProps {
    leftIcon?: string,
    rightIcon?: string,
}

const ModeSwitcher: React.FC<IProps> = ({
    leftIcon = Sun,
    rightIcon = Moon
}) => {
    const { theme, toggleTheme } = useTheme();

    const CustomSwitch = styled(Switch)(({ theme }) => ({
        width: 62,
        height: 34,
        padding: 7,
        '& .MuiSwitch-switchBase': {
            margin: 1,
            padding: 0,
            transform: 'translateX(6px)',
            '&.Mui-checked': {
                color: '#fff',
                transform: 'translateX(22px)',
                '& .MuiSwitch-thumb:before': {
                    backgroundImage: `url(${rightIcon})`,
                },
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: '#aab4be',
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#8796A5',
                    }),
                },
            },
        },
        '& .MuiSwitch-thumb': {
            background: 'var(--background-color)',
            border: '1px solid var(--text-dark)',
            width: 32,
            height: 32,
            '&::before': {
                content: "''",
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: `url(${leftIcon})`,
            },
        },
        '& .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: '#aab4be',
            borderRadius: 20 / 2,
            ...theme.applyStyles('dark', {
                backgroundColor: '#8796A5',
            }),
        },
    }));

    return (
        <CustomSwitch
            checked={theme === "dark"}
            onChange={toggleTheme}
        />
    );
};

export default ModeSwitcher;
